// Mandatory + optional prompts for Purple Partnerships profile editor.
export const MANDATORY_PROMPTS = [
  { id: "values", q: "What core values anchor your life?", maxLen: 280 },
  { id: "marriage_why", q: "Why a lavender marriage for you?", maxLen: 280 },
  { id: "lifestyle", q: "Describe your day-to-day lifestyle.", maxLen: 280 },
  { id: "kids", q: "Thoughts on raising children together?", maxLen: 280 },
  { id: "finance", q: "How do you approach money in partnership?", maxLen: 280 },
  { id: "bio", q: "Tell us about yourself & what you're looking for.", maxLen: 300 },
];

export const OPTIONAL_PROMPTS = [
  "The way to my heart is...",
  "My toxic trait is...",
  "Two truths and a lie:",
  "My ideal Sunday looks like...",
  "I'll fall for you if...",
  "What I'm currently watching is...",
  "Three things I can't live without:",
  "My love language is...",
  "I get unreasonably excited about...",
  "My most controversial opinion is...",
  "I'm looking for someone who...",
  "Dating me is like...",
  "My favorite quality in a person is...",
  "I geek out about...",
  "I'm a big fan of...",
  "The dorkiest thing about me is...",
  "I want someone who...",
  "Together, we could...",
  "On a perfect first date, we'd...",
  "My simple pleasures are...",
  "I take pride in...",
  "My friends would describe me as...",
  "My family would describe me as...",
  "I'm weirdly attracted to...",
  "The best way to ask me out is...",
  "Green flags I look for:",
  "Red flags I avoid:",
  "Unpopular opinion:",
  "The last book that changed me was...",
  "My go-to karaoke song is...",
  "My biggest dream is...",
  "I'm hoping you...",
  "I want us to talk about...",
  "Faith, spirituality, or none — for me it's...",
  "How I recharge:",
  "How I show love:",
  "How I handle conflict:",
  "What I'm working on right now:",
  "My favorite city in the world:",
  "If we'd be a duo, we'd be...",
  "My biggest flex:",
  "A small thing that makes my day:",
  "My favorite meal to share is...",
  "Best concert I've ever been to:",
  "My non-negotiables are...",
  "I'll know it's real when...",
  "I am most myself when...",
  "Petty argument I'd win:",
  "If money were no object, I'd...",
  "Something I'm proud of:",
];
